"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Todos los cursos",
    "className": "Nombre del taller",
    "continue": "Continuar",
    "courseChapter": "Capítulo",
    "courseEvaluate": "Evaluación",
    "courseHours": "Crédito",
    "courseInfo": "Detalle",
    "courseNote": "Notas",
    "coursesCategory": "Categorías de cursos",
    "electiveCourses": "Curso opcional",
    "pages": "Página",
    "relatedCourses": "Cursos relevantes",
    "requiredCourses": "Conferencia",
    "searchTips": "Ingrese el nombre del curso",
    "studentsNum": "Audiencias",
    "teachersDesc": "Profesor",
    "newCourse": "Últimos cursos"
  },
  "footer_zlb": {
    "aboutUs": "Sobre nosotros",
    "downLoad": "Descarga de aplicación",
    "qr": "Código QR"
  },
  "global_zlb": {
    "am": "AM",
    "night": "Noche",
    "pm": "PM"
  },
  "header_zlb": {
    "accoutPw": "Contraseña de la cuenta",
    "curDis": "En curso",
    "curUser": "Usuario actual",
    "edit": "Actualizar",
    "helpCenter": "Centro de ayuda",
    "hisDis": "Historial",
    "index": "Inicio",
    "joinStore": "Añadir a favoritos",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Mensaje",
    "setIndex": "Establecer como página de inicio",
    "userImg": "Foto de perfil"
  },
  "index_zlb": {
    "discuss": "Taller",
    "find": "Descubrir",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Yo"
  },
  "info_zlb": {
    "admin": "Administrador",
    "hasAgenda": "Ya se ha unido a la Agenda.",
    "noDown": "¡No hay archivos adjuntos para descargar!",
    "pleaseInp": "Acceda",
    "submit": "¡Enviado con éxito!",
    "withinTime": "La tarea aún no ha comenzado",
    "noSubmitWork": "Tarea no enviada"
  },
  "login_zlb": {
    "accountLogin": "Iniciar sesión",
    "accountNotEmpty": "La cuenta debe estar completada",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Cancelar",
    "captchaNotEmpty": "Debe completar el código de verificación",
    "captchaTips": "Código de verificación incorrecto",
    "changeEmail": "Actualizar correo electrónico",
    "changeEmailSuccess": "Dirección de correo electrónico actualizada.",
    "changeEmailSuccessTips": "Ha actualizado su correo electrónico.",
    "Confirm": "Confirmar",
    "currentEmail": "Correo electrónico actual",
    "emailCaptcha": "Código de verificación de correo electrónico",
    "emailCaptchaEmpty": "El código de verificación de correo electrónico no puede estar vacío",
    "encryEmail": "correo electrónico de seguridad",
    "error": "Error de código de verificación",
    "forget": "Contraseña olvidada",
    "formerEamil": "Correo electrónico original",
    "incorrectTips": "Error de entrada de nombre de usuario o contraseña",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Nuevo correo electrónico",
    "newEmailBinded": "El nuevo correo electrónico está vinculado a su cuenta de usuario.",
    "newEmailEmpty": "El correo electrónico nuevo no puede estar vacío",
    "newEmailFomat": "El nuevo formato de correo electrónico es incorrecto",
    "newEmailSupport": "Las direcciones de correo electrónico antigua y nueva no coinciden",
    "prevStep": "Último paso",
    "nextStep": "Próximo paso",
    "reset": "Reiniciar",
    "loginNow": "Inicia sesión ahora",
    "resetSuccess": "Restablecido con éxito",
    "resetSuccessTips": "Ha restablecido su contraseña. Inicie sesión",
    "msgCaptcha": "Código de verificación por SMS",
    "getCaptcha": "Obtener el código de verificación",
    "resetPassword": "Restablecer la contraseña",
    "loginFail": "¡Error de acceso. Inténtelo de nuevo!",
    "failTips": "Error de verificación",
    "inputUserName": "Nombre de usuario",
    "goHome": "Ir a inicio",
    "passwordFormat": "Las contraseñas deben contener entre 8 y 32 dígitos y números y letras mayúsculas y minúsculas.",
    "surePasswordEmpty": "Confirmar contraseña no puede estar vacío",
    "confirmNot": "La contraseña y la contraseña de confirmación no coinciden",
    "changePasswordSuccess": "Contraseña actualizada ",
    "continueLogin": "Iniciar sesión de nuevo",
    "orError": "Nombre de usuario o contraseña incorrecta",
    "orgEmailEmpty": "El correo electrónico original no puede estar vacío",
    "orgEmailFormat": "El formato de correo electrónico original es incorrecto",
    "orgEmailNot": "La dirección de correo electrónico original es incorrecta",
    "passWord": "Contraseña",
    "surePassword": "Confirmar Contraseña",
    "passwordBits": "Las contraseñas deben tener 6 caracteres como mínimo ",
    "passwordNotEmpty": "Debe rellenar la contraseña",
    "pWord": "Contraseña",
    "sign": "Iniciar sesión",
    "uName": "Cuenta",
    "userName": "Nombre de usuario",
    "validate": "Código de verificación",
    "verification": "Complete la verificación a continuación",
    "appdownload": "Descarga de la aplicación",
    "scancode": "Escanee el código QR para descargar",
    "poor": "Débil",
    "middle": "Medio",
    "strong": "Fuerte"
  },
  "login": {
    "logout": "Sesión cerrada",
    "resetLoginTips": "Ha cambiado su contraseña, debe iniciar sesión de nuevo y cerrar sesión automáticamente tras 3 segundos",
    "sure": "Confirmar",
    "cancel": "Cancelar",
    "captchaNotEmpty": "Debe completar el código de verificación",
    "accountNotEmpty": "La cuenta debe estar completada",
    "passwordNotEmpty": "Debe rellenar la contraseña",
    "inputCaptcha": "Código de verificación",
    "getCaptcha": "Obtener el código de verificación",
    "inputOrigPassword": "Ingrese la contraseña original",
    "inputNewPassowrd": "Ingrese una nueva contraseña",
    "confimPassword": "Confirmar Contraseña",
    "changePassword": "Cambiar contraseña",
    "nextStep": "Próximo paso",
    "resetPassword": "Restablecer la contraseña",
    "resetDone": "Contraseña restablecida con éxito",
    "msgCaptcha": "Código de verificación de correo electrónico"
  },
  "look_zlb": {
    "aboutLecturer": "Cursos relevantes",
    "benginLearn": "Comenzar a aprender",
    "chapter": "Capítulo",
    "delete": "Borrar",
    "details": "Detalle",
    "download": "Descargar",
    "dynamic": "Noticias",
    "evaluation": "Evaluación",
    "hotDyc": "Tendencias",
    "lecture": "Curso abierto",
    "lecturer": "Profesor",
    "lectureTest": "Categorías de cursos",
    "look": "Descubrir",
    "lookAll": "Ver todo",
    "note": "Notas",
    "score": "Puntuación"
  },
  "myMessage_zlb": {
    "passwordError": "Error de entrada de contraseña original",
    "aboutUs": "Sobre nosotros",
    "allcourse": "Todos los cursos",
    "atypism": "Las dos contraseñas no coinciden",
    "birth": "Fecha de nacimiento",
    "cancel": "Cancelar",
    "carryOut": "Completo",
    "changePassword": "Cambiar contraseña",
    "chineseName": "Nombre chino",
    "chineseNamePlaceholder": "Ingrese el nombre chino",
    "code": "Código de verificación",
    "codeError": "Error de código de verificación",
    "comment": "Comentario",
    "complete": "Completo",
    "completeUserInfo": "Complete la información personal",
    "confirm": "Confirmar Contraseña",
    "continueStudy": "Continuar",
    "country": "País",
    "countryName": "Nombre",
    "countryNamePlaceholder": "Ingrese su nombre",
    "countryPlaceholder": "Seleccione un país",
    "courseLearned": "Completado",
    "delete": "Borrar",
    "documentType": "Tipo de documento ID",
    "downloaded": "Descargado",
    "downloading": "Descargando",
    "eduLevel": "Nivel de Educación",
    "eduLevelPlaceholder": "Seleccione el nivel de educación",
    "email": "Correo electrónico",
    "emailCode": "Código de verificación de correo electrónico",
    "gender": "Género",
    "genderPlaceholder": "Seleccione el género",
    "getCode": "Obtener el código de verificación por correo electrónico",
    "hasSent": "Enviado",
    "helpCenter": "Centro de ayuda",
    "hour": "Hora",
    "improveInformation": "Complete su información personal",
    "joinClasses": "Cursos realizados",
    "joinDis": "Talleres realizados",
    "learned": "Terminado",
    "learning": "En curso",
    "lecture": "Curso",
    "mailbox": "Correo electrónico",
    "mailboxValidate": "Error de verificación de correo electrónico",
    "man": "Masculino",
    "management": "Ajustes",
    "minutes": "x horas x minutos",
    "modify": "Actualizar",
    "modifyEmail": "Actualizar correo electrónico",
    "my": "Yo ",
    "myCertificate": "Mi certificado",
    "mycourse": "Mi curso",
    "myDownload": "Mi descarga",
    "myLecture": "Mi curso",
    "myNotes": "Mi nota",
    "newMail": "Nuevo correo electrónico",
    "newPassword": "Nueva contraseña",
    "nextStep": "Próximo paso",
    "orError": "Nombre de usuario o contraseña incorrecta",
    "origin": "De",
    "originalPassword": "Contraseña original",
    "password": "Contraseña",
    "phone": "Número de teléfono",
    "pleChoose": "Seleccione la fecha de nacimiento",
    "post": "Publicar",
    "postPlaceholder": "Ingrese la publicación",
    "religion": "Religión",
    "religionPlaceholder": "Elija la religión",
    "retrievePassword": "Recuperar contraseña",
    "setUp": "Ajustes",
    "signOut": "Cerrar sesión",
    "something": "Querría decir",
    "submit": "Enviar",
    "sureDelte": "Asegúrese de que desea eliminarlo",
    "teacher": "Conferenciante",
    "learnYet": "Aún no he empezado a aprender",
    "uName": "Nombre de usuario",
    "uNamePlaceholder": "Nombre de usuario",
    "userCenter": "Información personal",
    "username": "Nombre de usuario",
    "validateMsg": "Error de verificación",
    "woman": "Femenino",
    "learnTo": "Progreso",
    "myRecord": "Mi registro",
    "plePhone": "Ingrese el número de teléfono"
  },
  "notice_zlb": {
    "delete": "Borrar",
    "home": "Inicio",
    "lettre": "Mensaje privado",
    "lettreEmpty": "El mensaje privado no puede estar vacío",
    "messageDetail": "Detalles del mensaje",
    "myMessage": "Mi mensaje",
    "notice": "Aviso",
    "nowBavarder": "Ahora puede empezar a chatear",
    "send": "Enviar"
  },
  "play_zlb": {
    "networkTip": "Notificación de red",
    "streamHighTip": "La conexión de red actual es estable. Hemos cambiado al modo de alta definición.",
    "streamHighType": "HD",
    "streamNormTip": "La conexión de red actual es inestable. Hemos cambiado al modo de definición estándar.",
    "streamNormType": "SD",
    "liveTimeDes": "Tiempo en vivo",
    "livePlayWait": "En vivo no iniciado",
    "livePlayEnd": "En vivo finalizado"
  },
  "questionnaire_zlb": {
    "handed": "Enviar",
    "saveFailed": "Error al guardar",
    "examList": "Lista de preguntas del examen"
  },
  "research_zlb": {
    "afternoon": "PM",
    "all": "Todo",
    "allCalendar": "Toda la agenda",
    "alumniBook": "Miembro",
    "broadcast": "x iniciar la transmisión",
    "carriedout": "En curso",
    "certificate": "Certificado",
    "comment": "Comentario",
    "comments": "Todos los comentarios x",
    "courses": "Referencia",
    "curDis": "En curso",
    "default": "No empezado",
    "delete": "Borrar",
    "detail": "Detalle",
    "discuss": "Foro",
    "end": "Terminado",
    "endAssess": "Evaluación finalizada",
    "enterAssess": "Comenzar evaluación",
    "assessButton": "Comentarios",
    "evaluation": "Evaluación",
    "fileAcept": "Tipo de archivo incorrecto, cargue de nuevo.",
    "fileSize10": "El archivo seleccionado supera los 10m, cargue de nuevo.",
    "hisDis": "Historial",
    "lecture": "Referencia",
    "live": "En vivo",
    "livebroadcast": "Transmisión en vivo",
    "minutes": "hace x minutos",
    "month": "Mes",
    "morning": "AM",
    "noDiscussion": "Sin taller",
    "noSchedule": "Sin agenda",
    "notice": "Aviso",
    "notification": "Aviso no leído",
    "offline": "Conferencia presencial",
    "onging": "En curso",
    "online": "En línea",
    "operation": "Tarea",
    "over": "Terminado",
    "participated": "Ya participó",
    "notParticipate": "Aún por participar",
    "failedCourse": "No aprobado",
    "passedCourse": "Aprobar",
    "preparation": "Preparación de la tarea",
    "preparations": "Preparación de la tarea",
    "preschoolLecture": "Conferencia de preparación",
    "questionnaire": "Cuestionario",
    "questionType ": "elección múltiple (sólo una respuesta es correcta; marque todas las respuestas correctas)",
    "readySay": "Querría decir",
    "replies": "Tiene x nuevas respuestas",
    "save": "Guardar",
    "schedule": "Agenda",
    "searchC": "Busque temas que le interesen",
    "seeAssess": "Ver evaluación",
    "submit": "Enviar",
    "submitHomewor": "Cancelar",
    "task": "Tarea",
    "taskToday": "Tarea para hoy",
    "video": "Video",
    "week": "Semana",
    "yourcomment": "Escriba su comentario",
    "legend": "Leyenda",
    "sunday": "Domingo",
    "monday": "Lunes",
    "tuesday": "Martes",
    "wednesday": "Miércoles",
    "thursday": "Jueves",
    "friday": "Viernes",
    "saturday": "Sábado",
    "consult": "Materiales de referencia",
    "schedules": "Tareas",
    "calendar": "Calendario",
    "waitAssesment": "Cuestionario a enviar",
    "year": "Año",
    "day": "Día",
    "preview": "Avance",
    "resource": "Descargar"
  },
  "retrieve_zlb": {
    "emailEmpty": "La dirección de correo electrónico no puede estar vacía.",
    "emailVerif": "Verificación de correo electrónico"
  },
  "task_zlb": {
    "downF": "Descargar archivos adjuntos",
    "repeatUp": "Volver a cargar",
    "ruY": "Si se ha cargado un archivo adjunto en la aplicación, se sobrescribirá si carga otro en el PC.",
    "submitC": "Ingrese lo que quiera enviar",
    "uploadF": "Cargar archivos adjuntos"
  },
  "upload_zlb": {
    "clickHere": "Pulse aquí",
    "limit": "El formato de archivo es compatible con PNG, el tamaño de JPG no puede superar",
    "preview": "Vista previa después de cargar la imagen",
    "upload": "Cargar"
  },
  "index": {
    "setAsHomePage": "Establecer como página de inicio",
    "addCollection": "Añadir a favoritos",
    "telephone": "Línea directa",
    "Help": "Centro de ayuda",
    "SystemMessage": "Notificación del sistema",
    "message": "Mensaje privado",
    "emptyMessage": "Eliminar",
    "checkAllMessage": "Ver todo",
    "noMessage": "Sin datos",
    "fullScreen": "Visualización de pantalla completa",
    "ExitSystem": "Salir de este sistema",
    "back": "Atrás",
    "top": "Arriba",
    "backToTop": "Volver arriba",
    "homePage": "Inicio",
    "favoriteTips": "Debido a la limitación del navegador 360 / navegador Google, presione Ctrl + D para recopilar manualmente.",
    "autoSetHomeTips": "Su navegador no admite los ajustes automáticos de la página de inicio, utilice el menú del navegador para ajustar manualmente.",
    "currentUser": "Usuario actual",
    "userHead": "Foto de perfil",
    "accountPassword": "Contraseña de la cuenta",
    "change": "Actualizar",
    "head": "Foto de perfil",
    "continueStudy": "Continuar",
    "startStudy": "Comenzar a aprender"
  },
  "course": {
    "count": "general",
    "item": "Artículo",
    "up": "Página anterior",
    "next": "Siguiente página",
    "items": "por página",
    "go": "Saltar a",
    "page": "Página",
    "man": "Usuario",
    "score": "Puntuación",
    "courseYear": "Año",
    "courseTeachers": "Conferenciante",
    "noDesc": "Sin introducción",
    "teachersDesc": "Perfil del profesor",
    "checkLog": "Ver registros",
    "startStudy": "Comenzar a aprender",
    "JoinLearning": "Unirse",
    "isEvaluate": "Evaluado",
    "deleteNoteButton": "Borrar",
    "closeButton": "Cerrar",
    "noteSource": "De"
  },
  "onlineclass": {
    "myScore": "Mi puntuación",
    "comments": "Comentario",
    "iknow": "Lo sé",
    "detail": "Detalle",
    "inforCertificate": "Certificado",
    "wantTalk": "Quiero comentarlo",
    "inputTalkContent": "Ingrese el comentario",
    "publish": "Publicar",
    "undo": "Cancelar",
    "reply": "Responder",
    "delete": "Borrar",
    "Learned": "Completado",
    "isDelete": "¿Seguro que quiere eliminarlo?",
    "submitTime": "Tiempo de envío",
    "to": "a",
    "download": "Descargar"
  },
  "usercenter": {
    "htllo": "Hola",
    "welcomeMessage": "Que tenga un buen día",
    "searchTips": "Busque el curso que quiera",
    "myCertificate": "Mi certificado",
    "startQuestionnaire": "Empiece a contestar el papel",
    "empty": "nada",
    "confirmDelete": "Confirmación de eliminación",
    "confirmDeleteTips": "¿Seguro que quiere eliminarlo?",
    "delete": "Borrar",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Fin del aprendizaje",
    "tips": "Consejos",
    "playTips": "Conejos: pulse el botón \"Finalizar aprendizaje\" en la esquina superior derecha para salir. Si finaliza el aprendizaje cerrando el navegador, puede que su tiempo de aprendizaje no se registre correctamente.",
    "notShowAgain": "No recordármelo de nuevo",
    "gotIt": "Lo sé",
    "chapter": "Capítulo",
    "language": "Idioma",
    "chapterText1": "No.",
    "chapterText2": "Capítulo",
    "note": "Notas",
    "noteBlockTitle": "Notas",
    "evaluate": "Evaluación",
    "evaluateStar": "Estrella",
    "saveEvaluate": "Enviar",
    "notePlaceholder": "Tome notas",
    "closeTips": "Puede que los cambios que realizó no se guarden",
    "closeButton": "Abandonar",
    "autoStop": "Dejar de reproducir automáticamente",
    "autoStopTips": "Tiempo de espera de inactividad del usuario. La reproducción se detiene automáticamente.",
    "confirmOut": "¿Seguro que quiere dejar de reproducir?",
    "closeOrNot": "Cerrar la ventana actual",
    "noCoursePlay": "No se han encontrado fuentes reproducibles en el curso actual",
    "attention": "¡Atención!"
  },
  "assessment_zlb": {
    "score": "Puntuación",
    "evalSuccess": "Evaluación con éxito"
  },
  "undefined": {}
};